import { Routes } from '@angular/router';
import { authenticatedRouteGuards, canActivateProjects } from '@shared/guard/guard';
import { PageKey } from '@shared/services/page/models/page.key';

export const weeklyAllocationsV2Route: Routes = [
  {
    path: 'weekly-allocations',
    loadComponent: () => import('./pages/allocation-board/allocation-board.component').then(m => m.AllocationBoardComponent),
    canActivate: [...authenticatedRouteGuards, canActivateProjects],
    data: {
      title: 'Alocação',
      key: PageKey.WEEKLY_ALLOCATIONS
    }
  }
];
